export default __webpack_public_path__ + "static/media/news-thumb7.49c672cb.png";